import AvatarCard from './AvatarCard'

function AvatarsSection({ isLoadingAvatars, generatedAvatars, hasApiKey, onOpenApiKeyModal, onCopyAssetId }) {
    try {
        return (
            <div className="mb-8 bg-gray-50 p-6 rounded-lg border border-gray-200" data-name="avatars-section">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold">
                        <i className="fas fa-user-circle text-purple-600 mr-2"></i>
                        HeyGen 數字人資產
                    </h2>
                    <div>
                        {hasApiKey ? (
                            <div className="text-sm text-green-600 flex items-center">
                                <i className="fas fa-check-circle mr-1"></i>
                                API Key 已設定
                            </div>
                        ) : (
                            <button 
                                onClick={onOpenApiKeyModal}
                                className="text-sm px-3 py-1 bg-purple-600 text-white rounded hover:bg-purple-700"
                                data-name="set-api-key-button"
                            >
                                設定 API Key
                            </button>
                        )}
                    </div>
                </div>
                
                {isLoadingAvatars ? (
                    <div className="flex justify-center py-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
                    </div>
                ) : generatedAvatars.length > 0 ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        {generatedAvatars.map(avatar => (
                            <AvatarCard 
                                key={avatar.id} 
                                avatar={avatar} 
                                onCopyAssetId={onCopyAssetId} 
                            />
                        ))}
                    </div>
                ) : (
                    <div className="text-center py-8 bg-white rounded-lg border border-gray-200">
                        <div className="text-5xl mb-4 text-gray-300">
                            <i className="fas fa-user-circle"></i>
                        </div>
                        <h3 className="text-xl font-semibold text-gray-700 mb-2">尚無數字人資產</h3>
                        <p className="text-gray-600 mb-4">
                            您可以從語音記錄中選擇一個語音，然後點擊「生成數字人」按鈕來創建數字人資產
                        </p>
                        {!hasApiKey && (
                            <button 
                                onClick={onOpenApiKeyModal}
                                className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                                data-name="setup-api-key-button"
                            >
                                <i className="fas fa-key mr-2"></i>
                                設定 HeyGen API Key
                            </button>
                        )}
                    </div>
                )}
            </div>
        );
    } catch (error) {
        console.error('AvatarsSection component error:', error);
        reportError(error);
        return null;
    }
}

export default AvatarsSection;